import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { useI18n } from "../contexts/I18nContext";
import AppCard from "../components/AppCard";
import { Plus, Smartphone } from "lucide-react";

export default function Dashboard() {
  const { t } = useI18n();
  const [apps, setApps] = useState(null);

  useEffect(() => {
    api.get("/apps").then((r) => setApps(r.data)).catch(() => setApps([]));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
      <div className="flex flex-wrap items-end gap-5 justify-between mb-12">
        <div>
          <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight" data-testid="dashboard-title">
            {t("dash_title")}
          </h1>
          <p className="text-zinc-600 mt-3 max-w-xl">{t("dash_sub")}</p>
        </div>
        <Link to="/builder" data-testid="dashboard-create" className="btn btn-primary btn-lg">
          <Plus className="w-4 h-4" strokeWidth={2.5} />
          {t("dash_create")}
        </Link>
      </div>

      {apps === null ? (
        <div className="surface-card p-12 text-center text-sm text-zinc-500" data-testid="dashboard-loading">
          {t("common_loading")}
        </div>
      ) : apps.length === 0 ? (
        <div className="surface-card p-14 text-center" data-testid="dashboard-empty">
          <div className="w-14 h-14 rounded-2xl bg-zinc-900 grid place-items-center mx-auto mb-5">
            <Smartphone className="w-6 h-6 text-white" strokeWidth={1.6} />
          </div>
          <h2 className="font-display text-2xl font-semibold tracking-tight">{t("dash_empty_title")}</h2>
          <p className="text-zinc-600 mt-2">{t("dash_empty_sub")}</p>
          <Link
            to="/builder"
            data-testid="dashboard-empty-cta"
            className="btn btn-primary btn-lg mt-6 inline-flex"
          >
            <Plus className="w-4 h-4" strokeWidth={2.5} />
            {t("dash_empty_cta")}
          </Link>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="dashboard-apps">
          {apps.map((app) => (
            <AppCard key={app.id} app={app} />
          ))}
        </div>
      )}
    </div>
  );
}
